/* Naturally Good Snacks header + footer behavior. */
(function () {
  if (window.__ngsChrome) return;
  window.__ngsChrome = true;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var ann = $('[data-ngs-announce]');
  var header = $('[data-ngs-header]');
  var threshold = ann ? parseInt(ann.dataset.threshold, 10) || 5900 : 5900;
  var fmt = (ann && ann.dataset.moneyFormat) || '${{amount}}';
  var total = ann ? parseInt(ann.dataset.cartTotal, 10) || 0 : 0;
  var count = null;

  function money(c) {
    var n = (Math.round(c) / 100).toFixed(2).split('.');
    var w = n[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, /no_decimals/.test(fmt) ? w : w + '.' + n[1]);
  }

  /* ---------- announcement rotation + cart-aware message ---------- */
  var msgs = ann ? $$('[data-ngs-ann]', ann) : [];
  var cartMsg = ann ? $('[data-ngs-ann-cart]', ann) : null;
  var idx = 0, timer = null, paused = false;
  function show(i) { msgs.forEach(function (m, j) { m.classList.toggle('is-on', j === i); }); }
  function rotate() {
    clearInterval(timer);
    if (reduce || msgs.length < 2 || total > 0) return;
    timer = setInterval(function () { if (!paused && !document.hidden) { idx = (idx + 1) % msgs.length; show(idx); } }, 4500);
  }
  if (ann) { ann.addEventListener('mouseenter', function () { paused = true; }); ann.addEventListener('mouseleave', function () { paused = false; }); }

  function renderCart() {
    var pct = Math.max(0, Math.min(100, total / threshold * 100));
    var left = Math.max(0, threshold - total);
    var line = left > 0 ? (ann ? ann.dataset.msgAway : '').replace('[amount]', money(left)) : (ann ? ann.dataset.msgFree : '');
    if (cartMsg) {
      if (total > 0) {
        cartMsg.hidden = false; cartMsg.textContent = line;
        msgs.forEach(function (m) { m.classList.remove('is-on'); });
        requestAnimationFrame(function () { cartMsg.classList.add('is-on'); });
      } else {
        cartMsg.hidden = true; cartMsg.classList.remove('is-on'); show(idx);
      }
    }
    rotate();
    $$('.cart-ring').forEach(function (r) { r.style.setProperty('--p', pct.toFixed(1)); });
    $$('[data-ngs-cart-total]').forEach(function (el) { el.textContent = money(total); });
    if (count !== null) $$('[data-ngs-cart-count]').forEach(function (el) { el.textContent = count; if (count > 0) el.removeAttribute('data-zero'); else el.setAttribute('data-zero', ''); });
    var dm = $('[data-ngs-dr-ship-msg]'), df = $('[data-ngs-dr-ship-fill]');
    if (dm) dm.textContent = total > 0 ? line : 'Free shipping on orders ' + money(threshold).replace(/\.00$/, '') + '+';
    if (df) df.style.width = pct + '%';
  }
  var last = null;
  function refresh() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var grew = last !== null && c.item_count > last;
        total = c.total_price; count = c.item_count; last = c.item_count; renderCart();
        if (grew) $$('.hdr-cart').forEach(function (b) { b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); });
      }).catch(function () {});
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(refresh, 300); }
  renderCart();
  refresh();
  // any cart change on the page (theme, UpCart, our quick-add) triggers a refresh
  if (window.fetch && !window.fetch.__ngs) {
    var of = window.fetch;
    var wrapped = function (input) {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(u)) p.then(soon, soon);
      return p;
    };
    wrapped.__ngs = true; window.fetch = wrapped;
  }
  (function hook(n) {
    if (typeof window.upcartSubscribeCartUpdated === 'function') { try { window.upcartSubscribeCartUpdated(soon); } catch (e) {} }
    else if (n < 40) setTimeout(function () { hook(n + 1); }, 250);
  })(0);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) soon(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) soon(); });

  /* cart button opens the UpCart drawer when present */
  $$('[data-ngs-cart-open]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (typeof window.upcartOpenCart === 'function') { e.preventDefault(); try { window.upcartOpenCart(); } catch (err) { location.href = a.href; } }
    });
  });

  /* ---------- sticky header state ---------- */
  var lastY = window.scrollY;
  function onScroll() {
    if (!header) return;
    var y = window.scrollY;
    header.classList.toggle('is-scrolled', y > 10);
    if (Math.abs(y - lastY) > 6) { header.classList.toggle('is-down', y > lastY && y > 160); lastY = y; }
  }
  function setH() {
    if (header) document.documentElement.style.setProperty('--ngs-hdr-h', header.getBoundingClientRect().height + 'px');
    if (ann) document.documentElement.style.setProperty('--ngs-ann-h', ann.getBoundingClientRect().height + 'px');
  }
  if (header && 'ResizeObserver' in window) { var ro = new ResizeObserver(setH); ro.observe(header); if (ann) ro.observe(ann); }
  setH();
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- mega menu ---------- */
  var megaBtn = $('[data-ngs-mega]'), mega = $('[data-ngs-mega-panel]'), mt;
  function megaSet(open) {
    if (!megaBtn || !mega) return;
    mega.hidden = !open; megaBtn.setAttribute('aria-expanded', String(open));
  }
  if (megaBtn && mega) {
    megaBtn.addEventListener('click', function () { megaSet(mega.hidden); });
    var li = megaBtn.parentNode;
    [li, mega].forEach(function (el) {
      el.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) { clearTimeout(mt); megaSet(true); } });
      el.addEventListener('mouseleave', function () { if (window.matchMedia('(hover: hover)').matches) { clearTimeout(mt); mt = setTimeout(function () { megaSet(false); }, 180); } });
    });
    document.addEventListener('click', function (e) { if (!mega.hidden && !mega.contains(e.target) && !megaBtn.contains(e.target)) megaSet(false); });
  }

  /* ---------- drawer + search panels ---------- */
  var opener = null;
  function openPanel(id, btn) {
    var p = document.getElementById(id); if (!p) return;
    opener = btn || null;
    p.hidden = false; document.documentElement.style.overflow = 'hidden';
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var f = $('[data-ngs-q]', p) || $('button[data-ngs-close]', p);
    setTimeout(function () { if (f) f.focus(); }, 60);
  }
  function closePanels() {
    $$('[data-ngs-panel]').forEach(function (p) {
      if (p.hidden) return;
      p.hidden = true;
      $$('[aria-controls="' + p.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    });
    document.documentElement.style.overflow = '';
    if (opener) { try { opener.focus(); } catch (e) {} opener = null; }
  }
  $$('[data-ngs-open]').forEach(function (b) { b.addEventListener('click', function () { megaSet(false); openPanel(b.dataset.ngsOpen, b); }); });
  $$('[data-ngs-close]').forEach(function (b) { b.addEventListener('click', closePanels); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closePanels(); megaSet(false); }
    if (e.key === 'Tab') {
      var p = $$('[data-ngs-panel]').filter(function (x) { return !x.hidden; })[0];
      if (!p) return;
      var f = $$('a[href], button, input:not([type=hidden])', p).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
    if (e.key === '/' && !/input|textarea|select/i.test((document.activeElement || {}).tagName || '')) {
      if ($('#ngs-search')) { e.preventDefault(); openPanel('ngs-search'); }
    }
  });

  /* ---------- predictive search ---------- */
  var q = $('[data-ngs-q]'), out = $('[data-ngs-results]'), pop = $('[data-ngs-pop]'), st, ctrl;
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function search(term) {
    if (!out) return;
    if (!term) { out.innerHTML = ''; if (pop) pop.hidden = false; return; }
    if (ctrl && ctrl.abort) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    var url = root + 'search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); }).then(function (d) {
      var res = (d && d.resources && d.resources.results) || {};
      var ps = res.products || [], cs = res.collections || [];
      if (pop) pop.hidden = true;
      var h = '';
      if (cs.length) h += '<div class="sr-colls sr-chips">' + cs.map(function (c) { return '<a href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; }).join('') + '</div>';
      if (ps.length) {
        h += '<p class="sr-h">Snacks</p><div class="sr-list">' + ps.map(function (p) {
          var img = p.image ? '<img src="' + esc(p.image) + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" loading="lazy" width="60" height="60">' : '<span></span>';
          var price = p.price ? money(parseFloat(p.price) * 100) : '';
          var from = p.price_max && p.price_min && p.price_max !== p.price_min ? 'From ' : '';
          return '<a class="sr-item" href="' + esc(p.url) + '">' + img + '<span><b>' + esc(p.title) + '</b><small>' + (p.available === false ? 'Sold out' : '2 lb and 5 lb bags') + '</small></span><span class="sr-price">' + from + esc(p.price_min ? money(parseFloat(p.price_min) * 100) : price) + '</span></a>';
        }).join('') + '</div>';
        h += '<a class="sr-all" href="' + root + 'search?type=product&q=' + encodeURIComponent(term) + '">See all results for &ldquo;' + esc(term) + '&rdquo;</a>';
      }
      if (!h) h = '<p class="sr-empty">No snacks match &ldquo;' + esc(term) + '&rdquo;. Try a nut, fruit or flavor, like cashews or mango.</p>';
      out.innerHTML = h;
    }).catch(function () {});
  }
  if (q) q.addEventListener('input', function () { clearTimeout(st); var v = q.value.trim(); st = setTimeout(function () { search(v); }, 180); });

  /* ---------- footer columns: open on desktop, collapsible on mobile ---------- */
  var mq = window.matchMedia('(max-width: 989px)');
  function cols() { $$('[data-ngs-ftcol]').forEach(function (d) { if (mq.matches) d.removeAttribute('open'); else d.setAttribute('open', ''); }); }
  cols();
  if (mq.addEventListener) mq.addEventListener('change', cols);
  $$('[data-ngs-ftcol] summary').forEach(function (s) { s.addEventListener('click', function (e) { if (!mq.matches) e.preventDefault(); }); });
})();
